import { NgModule } from '@angular/core';
import { NxiCommonModule } from '@pershing/nxi-common';
import { MatButtonModule } from '@angular/material/button';

// This is required to expose all services associated with nxi-ng-contentmanagement module
import { ContentManagementService } from './services/content-management.service';
import { DisclosureContentService } from './services/disclosure-content.service';
import { ContentStudioService } from './services/content-studio.service';
import { ContentManagementComponent } from './components/contentManagement/content-management.component';
import { DisclosureContentComponent } from './components/disclosureContent/disclosure-content.component';
import { CMSTextComponent } from './components/text/cms-text.component';
import { CMSImageComponent } from './components/imageContent/cms-image.component';
import { SafePipe } from './pipe/SafePipe';
import { FaqsContentComponent } from './components/faqscontent/faqs-content.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FileDropModule } from 'ngx-file-drop';
import { ProgressDialogComponent } from './components/progress-dialog/progress-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ImageContentComponent } from './components/image-content/image-content.component';

export const PERSHING_CONTENT_MANAGEMENT_COMPONENTS: any[] = [
    ContentManagementComponent,
    DisclosureContentComponent,
    FaqsContentComponent,
    CMSTextComponent,
    CMSImageComponent,
    ProgressDialogComponent,
    ImageContentComponent
];

export const PERSHING_CONTENT_MANAGEMENT_SERVICE_PROVIDERS: any[] = [
    ContentManagementService,
    DisclosureContentService,
    ContentStudioService,
    SafePipe
];

@NgModule({
    imports: [
        NxiCommonModule,
        AngularEditorModule,
        FileDropModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule
    ],
    declarations: [
        ...PERSHING_CONTENT_MANAGEMENT_COMPONENTS, SafePipe
    ],
    providers: [
        ContentManagementService, DisclosureContentService, ContentStudioService, SafePipe
    ],
    exports: [
        ...PERSHING_CONTENT_MANAGEMENT_COMPONENTS
    ],
    entryComponents: [
        ...PERSHING_CONTENT_MANAGEMENT_COMPONENTS
    ]
})
export class ContentManagementModule { }
